export default __webpack_public_path__ + "static/media/app-store.5e0c3f10.svg";